import React from "react";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import One from "../../assets/img/sponsors/1.png";
import Two from "../../assets/img/sponsors/2.png";
import Three from "../../assets/img/sponsors/3.png";
import Four from "../../assets/img/sponsors/4.png";
import Five from "../../assets/img/sponsors/5.png";
import Six from "../../assets/img/sponsors/6.png";
import Seven from "../../assets/img/sponsors/7.png";
import Eight from "../../assets/img/sponsors/8.png";
import Nine from "../../assets/img/sponsors/9.png";
import Ten from "../../assets/img/sponsors/10.png";
import Eleven from "../../assets/img/sponsors/11.png";
import Twelve from "../../assets/img/sponsors/12.png";
import Thirteen from "../../assets/img/sponsors/13.png";
import Fourteen from "../../assets/img/sponsors/14.png";
import Fifteen from "../../assets/img/sponsors/15.png";
import Sixteen from "../../assets/img/sponsors/16.png";
import Seventeen from "../../assets/img/sponsors/17.png";
import Eighteen from "../../assets/img/sponsors/18.png";
import Nineteen from "../../assets/img/sponsors/19.png";
import Twenty from "../../assets/img/sponsors/20.png";
import TwentyOne from "../../assets/img/sponsors/21.png";

function Partners() {
  return (
    <section className="layout-pt-sm layout-pb-sm">
      <div className="container">
        <Swiper
          className="pt-60 pb-60 h-300"
          spaceBetween={50}
          breakpoints={{
            768: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            769: {
              slidesPerView: 5,
              spaceBetween: 40,
            },
          }}
          //   navigation
          //   pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          loop={true}
          loopFillGroupWithBlank={true}
          modules={[Autoplay]}
        >
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={One} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Two} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Three} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Four} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Five} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Six} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Seven} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Eight} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Nine} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Ten} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Eleven} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Twelve} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Thirteen} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Fourteen} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Fifteen} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Sixteen} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Seventeen} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Eighteen} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Nineteen} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={Twenty} alt="bob" />
          </SwiperSlide>
          <SwiperSlide style={{ width: "100%", height: "50px" }}>
            <img src={TwentyOne} alt="bob" />
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
}

export default Partners;
